module.exports = __webpack_public_path__ + "static/media/iconAttestationActive.7b60d508.svg";